<script setup>
import { useRoute } from "vue-router"
import { userProfile, getSchoolStaff } from "@/services/ApiUrlService"
import { useAuthStore } from "@/stores/authStore"
import { useAppStore } from "@/stores/appStore"
import { useCustomSwal } from "@/composables/usePopup"
import { IS_MM_REPORTS_LIST, IS_MB_REPORTS_LIST, IS_ALL_REPORTS_LIST } from "@/utils/constant"

import ReportService from "@/services/ReportService"

definePage({
  meta: {
    layout: "blank",
    public: true,
  },
})
const CAMPAIGN = import.meta.env.VITE_CAMPAIGN
const { showCustomSwal } = useCustomSwal()
const route = useRoute()
const authStore = useAuthStore()
const appStore = useAppStore()

const email = ref(cleanEmail(route.query.email))
const token = ref(route.query.token)
const survey = ref(route.query.survey)
const admin = ref(route.query.isAdmin)
const redirect = ref(route.query.redirect)

const getProfileUser = async () => {
  try {
    const { data } = await useApi(`${userProfile}/${email.value}`)

    if (data.value?.schoolStaffId) {
      getProfile(data.value?.schoolStaffId)
    }

    if (survey.value) {
      authStore.setSurveyRoute(survey.value)
    }
    if (redirect.value) {
      authStore.setRedirectReportStudent(redirect.value)
    }

    authStore.loginByRoute(data.value, admin.value)
  } catch (error) {
    console.log(error)
  }
}
async function getListReport() {
  try {
    const response = await ReportService.listReport()
    console.log('callback page', response)
    let result = response
    if (+IS_MB_REPORTS_LIST === 1) {
      result = response.map(item => ({
        school: item.school,
        programs: item.programs.filter(p => p.programLevel === 2)
      }))
      appStore.setListReport(result)
    } else if (+IS_MM_REPORTS_LIST === 1) {
      result = response.map(item => ({
        school: item.school,
        programs: item.programs.filter(p => p.programLevel === 1)
      }))
      appStore.setListReport(result)
    } else if (+IS_ALL_REPORTS_LIST === 1) {
      appStore.setListReport(response)
    }
  } catch (error) {
    console.log(error)
      await showCustomSwal({
        title: $gettext("Error"),
        text:
          error.message ||
          $gettext("An error has occurred."),
      })
  }
}
const getProfile = async (schoolStaffId) => {
  try {
    const { data } = await useApi(`${getSchoolStaff}/${schoolStaffId}`)

    useAuthStore().setProfileUser(data.value)
  } catch (error) {
    Toast.fire({
      icon: "error",
      title: $gettext("Something went wrong"),
    })
  }
}
// callback?token=08a221c7-2ff4-4ff0-9b8a-43c4e1a4e7b5&email=anne.courtois@noschool.fr&survey=861
// localhost:8000/callback?token=74fe6dc0-423d-41ca-8201-06d5c416ef6b&email=quang.bui2@silkwires-dev.com&survey=861
watch(
  [() => email.value, () => token.value],
  async ([newEmail, newToken]) => {
    if (newEmail && newToken) {
      useCookie("accessToken").value = newToken
      useCookie("email").value = newEmail
      await getProfileUser()
    }
    if (+CAMPAIGN == 0) {
      await nextTick()
      await getListReport()
    }
  },
  { immediate: true }
)
</script>
<template>
  <Waiting :show="true" />
</template>
<style lang="scss" scoped></style>
